import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { CurrentShareholderGeneralMeetingModel } from '../../../models/current-shareholder-general-meeting.model';
import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';

@Component({
    selector: 'sl-personal-info',
    templateUrl: './personal-info.component.html',
    styleUrls: ['./personal-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalInfoComponent implements OnInit {
    personalInfo: CurrentShareholderGeneralMeetingModel;

    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    ngOnInit(): void {
        this.generalMeetingsResource.getCurrentForShareholder().subscribe(r => (this.personalInfo = r.value));
    }
}
